<template>
    <div>
        <h3>{{title}}</h3>
        <span class="help-text" v-translate>You can share a list of invoices sent to this customer. The link gives public access to view these invoices and can be shared with anyone.</span>

        <div class="pr-sm-3 pb-5">
            <b-form>
                <b-form-row>
                    <b-col md="4">
                        <b-form-group id="input-group-1" label-class="gk-label-margin gk-modal-label" label-for="input-1">
                            <template slot="label">
                                <span v-translate>Recipient</span>*
                            </template>
                            <b-input-group>
                                <b-form-input v-model="details.recipients" type="email" :placeholder="$gettext('sample@email.com')" />
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group id="input-group-2" label-class="gk-label-margin gk-modal-label" label-for="input-2">
                            <template slot="label">
                                <span v-translate>Subject</span>*
                            </template>
                            <b-input-group>
                                <b-form-input v-model="details.subject" type="text" />
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group id="input-group-3" label-class="gk-label-margin gk-modal-label" label-for="input-3">
                            <template slot="label">
                                <span v-translate>Message</span>*
                            </template>
                            <b-input-group>
                                <b-form-textarea v-model="details.message" rows="12" />
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                </b-form-row>
            </b-form>
            <GekkoButton 
              @click="showPublicLink()"
              :text="$gettext('Get public link')" 
              icon="fa-solid fa-link" 
              variant="link" 
              class="text-info"
            />
            <b-row v-if="getPublicLinkState" class="link-row">
                <b-col sm="10" class="mb-2 mb-sm-0"><b-form-input id="link-clipboard" :value="link" type="text" readonly /></b-col>
                <b-col sm="2">
                    <GekkoButton 
                        @click="copyToClipboard()"
                        :text="$gettext('Copy link')" 
                        icon="fa-regular fa-copy" 
                        variant="outline-primary" 
                    />
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
import GekkoButton from "@/components/GekkoButton";
import InvoiceService from "@/store/services/invoice.service";
import CompanyService from "@/store/services/company.service";
import UserService from "@/store/services/user.service";
import CustomerService from "@/store/services/customer.service";

export default {
    name: "ShareInvoices",
    components: {GekkoButton},
    props: {
        contactDetails: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            title: null,
            getPublicLinkState: false,
            details: {
                recipients: null,
                subject: null,
                message: null,
                sender_company: window.company_id,
            },
            link: null
        }
    },
    created() {
        let vm = this;

        CompanyService.getCurrent().then(function(response) {
            vm.link = window.location.origin + window.Urls['invoices-report'](vm.contactDetails.uuid, 1, 'all');
            let senderCompanyName = response.data.name;
            vm.title = vm.$gettext("Share invoices to ") + vm.contactDetails.name;
            vm.details.recipients = vm.contactDetails.email;
            vm.details.subject = vm.$gettext("Invoice report from ") + senderCompanyName;
            UserService.retrieveCurrent().then(function(response2) {
                vm.details.message = vm.$gettext("Hi,\n\nPlease find down below the link to the list of invoices I have sent you.\n")
                + vm.link + vm.$gettext("\n\nKind regards,\n") + response2.data.display_name;
            });
        });
    },
    methods: {
        showPublicLink() {
            this.getPublicLinkState = true;
        },
        sendEmail() {

            
            let vm = this;

            this.contactDetails.is_invoice_report_public = true;
            CustomerService.update(this.contactDetails.id, this.contactDetails);

            if(this.validateEmail(this.details.recipients)) {
                InvoiceService.sendReport(this.contactDetails.id, this.details).then(function() {
                    vm.$store.commit('setAlert', {
                        title: vm.$gettext("Success"),
                        text: vm.$gettext("An email was sent to ") + vm.contactDetails.name,
                        duration: 4
                    });
                }).catch(function () {
                    vm.$store.commit('setAlert', {
                        title: vm.$gettext("Ups. Something went wrong"),
                        text: vm.$gettext("Error sending the email."),
                        variant: "error",
                        duration: 4
                    });
                });
            } else {
                this.$store.commit('setAlert', {
                  title: this.$gettext("Wrong email address"),
                  text: this.$gettext("Please enter a valid email address."),
                  variant: "error",
                  duration: 4
                });
            }
        },
        validateEmail(email) {
            const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        },
        copyToClipboard() {
            this.contactDetails.is_invoice_report_public = true;
            CustomerService.update(this.contactDetails.id, this.contactDetails);
            
            var el = document.getElementById("link-clipboard");
            el.select();
            el.setSelectionRange(0, 99999);
            document.execCommand('copy');
            this.$store.commit('setAlert', {
                title: this.$gettext("Success"),
                text: this.$gettext("Link copied to the clipboard."),
                duration: 4
            });
        }
    }
}
</script>

<style scoped>

.form-row {
    padding-top: 15px;
    padding-bottom: 15px;
    display: block;
}

.link-row {
    padding-top: 15px;
    padding-bottom: 15px;
}

.help-text {
    color: #888;
    font-size: 14px;
}
</style>